(function (window) {
    "use strict";
    function definePaymentTypeHelper() {
        let paymentTypeHelper = {};
        paymentTypeHelper.paymentType = {
            CUF: 1,
            COD: 2,
            sevenDays: 3,
            fourteenDays: 4,
            thirtyDaysFromInvoiceDate: 5,
            thirtyDaysFromStatement: 6
        };
        return paymentTypeHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (paymentTypeHelper) === "undefined") {
        window.paymentTypeHelper = definePaymentTypeHelper();
    } else {
        console.log("paymentTypeHelper already defined.");
    }
})(window);